var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-content',[_c('ntm-block',{attrs:{"title":"TV CODE","init-collapse":false,"collapsable":false},scopedSlots:_vm._u([{key:"options",fn:function(){return [_c('span',{staticClass:"mb-0 font-size-h4 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.formattedTvCode)+" ")]),_c('button',{staticClass:"btn btn-sm",class:{
            'btn-warning': _vm.settings.tvCode,
            'btn-success': !_vm.settings.tvCode
          },on:{"click":_vm.generateUserTvCode}},[_c('i',{staticClass:"fa fa-undo"})])]},proxy:true}])})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }